module.exports = __webpack_public_path__ + "media/images/athletes/4150-1f77dfc43a421de560ba2c950504831a.png";